
import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { auth } = Dictionary

const Auth = {
  checkAuthorization: async (paramsObj) => {
    return axios.get(baseURL + auth.checkAuthorization(),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + jobs.jobs(), data)
  },
  delete: async (id) => {
    return axios.delete(BASE_URL + jobs.jobsById(id))
  },
  edit: async (id, data) => {
    return axios.put(BASE_URL + jobs.jobsById(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(BASE_URL + jobs.jobsById(id))
  },
}
export default Auth